export { Badge } from './badge.component'
export type { BadgeProps } from './badge.types'
